import React from 'react';

//Componentes
import TableContainer from '../../components/table/TableContainer';

//Estilos
import './DJCEList.css';

function DJCEList({ functions, states }) {
    const {
        register,
        handleSubmit,
        formState: { errors },
        newDJCE,
    } = functions;

    const { DJCEListData, tableData, viniedos, settings, EnableBtn } = states;

    return (
        <div className="DJCEList-container">
            {DJCEListData.length > 0 ? (
                <>
                    <TableContainer tableData={tableData} />
                </>
            ) : (
                <h3>No tiene ninguna Declaración de Cosecha Efectiva</h3>
            )}
            {new Date(settings?.djcp_rango_inicio) <
                new Date() <
                new Date(settings?.djcp_rango_fin) && (
                <div className="DJCEList-footer">
                    <form onSubmit={handleSubmit((data) => newDJCE(data))}>
                        <select {...register('myViniedo')}>
                            <option value={0}>Elegir Viñedo</option>
                            {viniedos?.map((v) => {
                                return (
                                    <option key={v.id} value={v.id}>
                                        {v.num}
                                    </option>
                                );
                            })}
                        </select>
                        <button
                            type="submit"
                            className="btn btn-primary"
                            disabled={EnableBtn === 0}
                        >
                            Nueva DJCE
                        </button>
                    </form>
                </div>
            )}
        </div>
    );
}

export default DJCEList;
